import api from "../../Api/feathers-client";

import { getRolesBySiteUuid } from "../Users/Services";
import { find } from "lodash";
let trainerRoleId, learnerRoleId, staffRoleId, inchargeRoleId;
const fetchRoles = async (props) => {
    let params = {
        query: {
            $select: ["uid", "title"],
            site_uuid: props.site_uuid,
        },
    };
    let resRolesData = await getRolesBySiteUuid(params);
    // console.log("resRolesData", resRolesData);

    let staff = find(resRolesData.data, { title: "staff" });
    let teaching = find(resRolesData.data, { title: "Trainer" });
    let learner = find(resRolesData.data, { title: "learner" });
    let incharge = find(resRolesData.data, { title: "Incharge" });
    //let idForParent = find(resRolesData.data, { 'title': 'parent' });

    trainerRoleId = teaching.uid;
    learnerRoleId = learner.uid;
    staffRoleId = staff.uid;
    inchargeRoleId = incharge.uid;
    return true;
};
const filterRoleTypes = async (totalUser, roleTypeId) => {
    let newArray = totalUser.filter(function (el) {
        return el.roleTypeId === roleTypeId
    }
    );
    return newArray;
};
export const totalUserOnline = async (props) => {
    // Trainer, staff, learner
    let fetchSetRolesIds = await fetchRoles(props);
    if (fetchSetRolesIds) {
        return new Promise(async (resolve, reject) => {
            try {
                let onlineUser = [];
                let params = {
                    query: {
                        site_uuid: props.site_uuid,
                    },
                };
                let totalUser = await api.service("who-is-online").find(params);
                onlineUser['incharge'] = await filterRoleTypes(totalUser, inchargeRoleId);
                onlineUser['trainer'] = await filterRoleTypes(totalUser, trainerRoleId);
                onlineUser['staff'] = await filterRoleTypes(totalUser, staffRoleId);
                onlineUser['learner'] = await filterRoleTypes(totalUser, learnerRoleId);
                resolve({
                    status: 200,
                    message: "Who is online by Site Uuid",
                    data: onlineUser,
                });
            } catch (error) {
                resolve(error);
            }
        });
    }
};

export const getHodeStatistics = async (props) => {
    return new Promise(async (resolve, reject) => {
        try {
            let params = {
                query: {
                    site_uuid: props.site_uuid,
                },
            };
            let resDashboradStatistics = await api.service("get-dashborad-statistics").find(params);
            resolve({
                status: 200,
                message: "Find dashborad statistics by site uid",
                data: resDashboradStatistics,
            });
        } catch (error) {
            resolve(error);
        }
    });
};

export const getStatisticsHours = async (props) => {
    return new Promise(async (resolve, reject) => {
        try {
            let params = {
                query: {
                    type: props.type,
                    duration: props.duration,
                    site_uuid: props.site_uuid,
                },
            };
            let resHours = await api.service("get-dashborad-statistics").get(null, params);
            resolve({
                status: 200,
                message: "Get statistics hours by site uid",
                data: resHours,
            });
        } catch (error) {
            resolve(error);
        }
    });
};

export const getLearnerLeaderBoard = async (params) => {
    return new Promise(async (resolve, reject) => {
        try {            
            let resLearnerLeaderboard = await api.service("get-dashboard-learner-leaderboard").find(params);
            resolve({
                status: 200,
                message: "Find Learner Leader Borad by site uid",
                data: resLearnerLeaderboard,
            });
        } catch (error) {
            resolve(error);
        }
    });
};